@if (!noHeaderRequired()) {
  <header>
    <!-- ログイン画面で使うロゴのヘッダー -->
    @if (logoHeader) {
      <div class="logo-header">
        <img class="logo" src="../assets/img/classi_logo.svg" />
        <h1 class="heading">{{ serviceName }}</h1>
      </div>
    }
    <!-- ログイン前の画面で使うspenデザインのヘッダー -->
    @if (!logoHeader) {
      <div class="before-login-header">
        <div class="logo"></div>
        <div class="title">{{ serviceName }}</div>
      </div>
    }
  </header>
}
